import styled, { css } from 'styled-components';

import { ImgGradient } from '../BillingUpdateLayout/Gradients.styles';

export const StyledImgGradient = styled(ImgGradient)`
  ${p => p.theme.isDark && css`filter: invert(90%);`}
`;
